import { IconLoader2, IconSparkles, IconX } from "@tabler/icons-react";

export const GenerationToast = ({
  progress,
  onOpen,
  onDismiss,
}: {
  progress: number | null; // 0..1, null while nothing is built yet
  onOpen: () => void;
  onDismiss: () => void;
}) => (
  <div className="tw-flex tw-w-[298px] tw-flex-col tw-gap-4 tw-overflow-hidden tw-rounded-2xl tw-bg-white tw-py-4 tw-shadow-md tw-outline tw-outline-1 tw-outline-offset-0 tw-outline-blue/5">
    <div className="tw-flex tw-flex-col tw-gap-2">
      <div className="tw-flex tw-items-start tw-justify-between tw-px-4">
        <span className="tw-flex tw-size-8 tw-items-center tw-justify-center">
          <IconSparkles className="tw-size-4 !tw-fill-none tw-text-violet-700" />
        </span>
        <button
          type="button"
          aria-label="Close"
          onClick={onDismiss}
          className="tw-flex tw-size-8 tw-items-center tw-justify-center tw-rounded-lg tw-text-blue-500 hover:tw-bg-blue-50 hover:tw-text-blue focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-violet-700"
        >
          <IconX className="tw-size-4" />
        </button>
      </div>
      <div className="tw-flex tw-flex-col tw-gap-2 tw-px-4">
        <p className="tw-m-0 tw-text-lg tw-font-semibold tw-leading-[1.4] tw-text-blue">
          We&apos;re turning your file into
          <br />a live Storydoc.
        </p>
        <p className="tw-m-0 tw-text-sm tw-text-blue-500">
          It can take a few minutes. Keep working and we&apos;ll let you know
          once it&apos;s ready!
        </p>
      </div>
    </div>
    <div className="tw-px-4">
      <button
        type="button"
        onClick={onOpen}
        className="tw-flex tw-h-9 tw-w-full tw-items-center tw-justify-center tw-gap-0.5 tw-rounded-lg tw-bg-blue-50 tw-px-3.5 tw-text-sm tw-font-medium tw-text-blue hover:tw-bg-blue-100 focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-violet-700"
      >
        <IconLoader2 className="tw-size-4 tw-animate-spin tw-text-violet-700" />
        <span className="tw-px-1 tw-opacity-50">Importing your file...</span>
        {progress != null && (
          <span className="tw-sr-only">{`${Math.round(progress * 100)}% built`}</span>
        )}
      </button>
    </div>
  </div>
);
